import { render, staticRenderFns } from "./AppMapaSerwisu.vue?vue&type=template&id=4d5da1f9&"
import script from "./AppMapaSerwisu.vue?vue&type=script&lang=js&"
export * from "./AppMapaSerwisu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports